var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgX(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Solid/x"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.43451 3.43427C3.74693 3.12185 4.25346 3.12185 4.56588 3.43427L8.0002 6.86858L11.4345 3.43427C11.7469 3.12185 12.2535 3.12185 12.5659 3.43427C12.8783 3.74669 12.8783 4.25322 12.5659 4.56564L9.13157 7.99995L12.5659 11.4343C12.8783 11.7467 12.8783 12.2532 12.5659 12.5656C12.2535 12.8781 11.7469 12.8781 11.4345 12.5656L8.0002 9.13132L4.56588 12.5656C4.25346 12.8781 3.74693 12.8781 3.43451 12.5656C3.12209 12.2532 3.12209 11.7467 3.43451 11.4343L6.86882 7.99995L3.43451 4.56564C3.12209 4.25322 3.12209 3.74669 3.43451 3.43427Z",
    fill: "#4D4D4D"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.ab0e674053f689aba648a0e5a35b2f35.svg";
export { ForwardRef as ReactComponent };